/**
 * Strip a run of one character from the end, the start or both ends of a string (round 7,
 * SonarQube typescript:S5852; docs/security/sonar-triage.md).
 *
 * `value.replace(/\/+$/, "")` reads well but is quadratic in V8: on `"////...x"` the engine
 * tries the run from every slash, and a 100,000-character value took 15 seconds. These run
 * in one pass and give exactly what `/c+$/`, `/^c+/` and `/^c+|c+$/g` gave
 * (`shared/__tests__/trimRuns.test.ts`).
 */

function assertOneChar(char: string): void {
  if (char.length !== 1) throw new Error("trimRun takes exactly one character");
}

/** `value.replace(/c+$/, "")` */
export function trimRunEnd(value: string, char: string): string {
  assertOneChar(char);
  let end = value.length;
  while (end > 0 && value[end - 1] === char) end -= 1;
  return end === value.length ? value : value.slice(0, end);
}

/** `value.replace(/^c+/, "")` */
export function trimRunStart(value: string, char: string): string {
  assertOneChar(char);
  let start = 0;
  while (start < value.length && value[start] === char) start += 1;
  return start === 0 ? value : value.slice(start);
}

/** `value.replace(/^c+|c+$/g, "")` */
export function trimRun(value: string, char: string): string {
  return trimRunEnd(trimRunStart(value, char), char);
}
